import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarehouse,
  faCalendarPlus,
  faBoxOpen,
  faBoxes,
  faShoppingCart,
  faDollyFlatbed,
} from '@fortawesome/free-solid-svg-icons';

const InventoryMiniDashboard = ({ inventory }) => {
  const indicators = inventory.reduce(
    (acc, item) => {
      acc.total_on_hand += item.total_on_hand;
      acc.total_expected += item.total_expected;
      acc.total_ordered += item.total_ordered;
      acc.total_allocated += item.total_allocated;
      acc.total_available += item.total_available;
      acc.on_purchase += item.on_purchase;
      acc.on_order += item.on_order;
      return acc;
    },
    {
      total_on_hand: 0,
      total_expected: 0,
      total_ordered: 0,
      total_allocated: 0,
      total_available: 0,
      on_purchase: 0,
      on_order: 0,
    }
  );

  // Updated function to format numbers with commas, forcing 'en-US' locale
  const formatNumber = (number) => number.toLocaleString('en-US');

  return (
    <div className="bg-white shadow rounded-lg p-4 mb-6">
      <div className="grid grid-cols-7 gap-4 text-center divide-x divide-gray-200">
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faWarehouse} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Total On Hand</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.total_on_hand)}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faCalendarPlus} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Total Expected</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.total_expected)}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faBoxOpen} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Total Ordered</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.total_ordered)}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faBoxes} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Total Allocated</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.total_allocated)}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faShoppingCart} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Total Available</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.total_available)}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faDollyFlatbed} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">On Purchase</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.on_purchase)}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faDollyFlatbed} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">On Order</p>
          <p className="text-lg font-semibold text-gray-800">{formatNumber(indicators.on_order)}</p>
        </div>
      </div>
    </div>
  );
};

export default InventoryMiniDashboard;
